export default __webpack_public_path__ + "static/media/b.c03c5752.png";